import { Box, styled } from '@mui/material'

// Global UI
import { TypographyH2, TypographyP } from '@/ui'

export const AbtHeroDiv = styled(Box)(({ theme }) => ({
  padding: `${theme.typography.pxToRem(75)} 0`,
}))

export const SectionHeadH2 = styled(TypographyH2)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(30),
  color: '#8E8778',
  fontWeight: 500,
  lineHeight: '1.3em',
  margin: 0,
  padding: 0,
  textTransform: 'uppercase',
}))

export const SectionParaText = styled(TypographyP)(({ theme }) => ({
  //   color: '#DBD29C',
  fontSize: theme.typography.pxToRem(16),
  fontWeight: 300,
  lineHeight: '1.643em',
  margin: '0 0 1em',
}))

export const CustomUL = styled('ul')({
  listStyleType: 'none',
  margin: 0,
  padding: 0,
})

export const CustomLI = styled('li')(({ theme }) => ({
  paddingBottom: `calc(${theme.typography.pxToRem(5)} / 2)`,
  fontSize: theme.typography.pxToRem(18),
  fontWeight: 300,
  lineHeight: '1.68em',

  '& .MuiSvgIcon-root': {
    color: '#000',
    fontSize: theme.typography.pxToRem(14),
  },

  '& span.text': {
    color: '#000',
    paddingLeft: theme.typography.pxToRem(5),
  },
}))
